// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { ArchiveEvent } from '@daml/ledger';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useArchiveOperatorConfiguration: () => UseMutationResult<
  ArchiveEvent<OperatorConfiguration>,
  string,
  {
    operatorConfigurationCid: ContractId<OperatorConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['archiveOperatorConfiguration', ledgerApi],
    mutationFn: async ({ operatorConfigurationCid }) => {
      return ledgerApi.archiveRegistryOperatorConfiguration(operatorConfigurationCid);
    },
  });
};

export default useArchiveOperatorConfiguration;
